import { useState, useEffect } from 'react';
import { Checkbox, RadioButton, Theme, useTranslation } from '@nextgen-web-framework/all';
import { useSelector, useDispatch } from 'react-redux';
import type { AppState, AppDispatch } from '@nextgen-web-framework/core';
import { SponsorSearchResponseInner, updateRegistrationData } from '@commerce-profile-webcomponents/sdk';
import SelectSponsor from './SelectSponsor/SelectSponsor';
import styles from './RegistrationSponsor.module.scss';

import { DoNotKnowSponsorFlow, RegistrationSponsorProps } from './types/propTypes';
import LeadsSearch from './LeadsSearch/LeadsSearch';

const RegistrationSponsor = ({
  isFieldDisabled,
  showABOSelected,
  isFocused,
  wrapperClass,
  doNotKnowAboFlowType = DoNotKnowSponsorFlow.RANDOM,
  state,
  city,
  onLeadsSearchHandler,
  onSponsorVerificationError,
}: RegistrationSponsorProps) => {
  const t = useTranslation();
  //slice
  const dispatch = useDispatch<AppDispatch>();
  const registrationFlowData = useSelector((state: AppState) => state.commerceProfile.registrationFlowData);
  const { selectSponsor, perosonalDetails } = registrationFlowData;

  const { sponsor, editSponsor } = selectSponsor;
  const sponsorExist = sponsor?.accountNumber;
  const [assignAbo, setAssignAbo] = useState(false);

  const updateRandomLeadsAssignConsent = (val: boolean) => {
    dispatch(
      updateRegistrationData({
        perosonalDetails: {
          ...perosonalDetails,
          assignAboCheckbox: val,
        },
      }),
    );
  };
  useEffect(() => {
    updateRandomLeadsAssignConsent(assignAbo);
  }, [assignAbo]);
  //local state
  const [iKnowABO, setIKnowABO] = useState(false);
  const [iDontKnowABO, setIDontKnowABO] = useState(false);
  const getRadioTheme = (radio: boolean) => (radio ? Theme.PURPLE : Theme.BLACK);
  const handleKnownABO = () => {
    setIKnowABO(true);
    setIDontKnowABO(false);
    updateRandomLeadsAssignConsent(false);
    onSponsorVerificationError?.(false);
  };
  const handleDontKnownABO = () => {
    setIKnowABO(false);
    setIDontKnowABO(true);
    onSponsorVerificationError?.(false);
    dispatch(
      updateRegistrationData({
        selectSponsor: {
          ...selectSponsor,
          sponsor: {},
        },
      }),
    );
  };
  //sponsor component props
  const sponsorProps = {
    isIdVerified: isFieldDisabled,
    showInternationalSponsor: sponsorExist,
    showInsideModal: showABOSelected,
    isFocused,
    onLeadsSearchHandler,
    onSponsorVerificationError,
  };

  useEffect(() => {
    if (!editSponsor) {
      setIKnowABO(true);
    }
  }, [editSponsor]);
  useEffect(() => {
    if (showABOSelected) {
      setIKnowABO(true);
    }
  }, []);
  return (
    <div
      className={`${styles['sponsor-details']}
    ${!showABOSelected ? styles['padding-bottom'] : ''} ${wrapperClass}`}
      data-testid="sponsor-details"
    >
      {editSponsor && !sponsorExist && (
        <div className={`${styles['sponsor-radio']} ${iKnowABO || iDontKnowABO ? styles['sponsor-padding'] : ''}`}>
          <RadioButton
            id="i-know-an-abo"
            data-testid="i-know-an-abo"
            className={styles['radio-button']}
            label={t('profile.RegistrationPersonalDetailsStep.IknowAnAbo')}
            checked={iKnowABO}
            theme={getRadioTheme(iKnowABO)}
            onClick={handleKnownABO}
            disabled={isFieldDisabled}
          />
          <RadioButton
            id="i-dont-know-an-abo"
            data-testid="i-dont-know-an-abo"
            className={styles['radio-button']}
            label={t('profile.RegistrationPersonalDetailsStep.IDontknowAnAbo')}
            checked={iDontKnowABO}
            theme={getRadioTheme(iDontKnowABO)}
            onClick={handleDontKnownABO}
            disabled={isFieldDisabled}
          />
        </div>
      )}
      <>
        {(iKnowABO || sponsorExist) && <SelectSponsor {...sponsorProps} />}
        {iDontKnowABO && doNotKnowAboFlowType == DoNotKnowSponsorFlow.RANDOM && (
          <Checkbox
            data-testid="assign-abo-checkbox-testid"
            text={t('profile.RegistrationPersonalDetailsStep.IDontknowAnAbocheckbox')}
            className="assign-abo-checkbox"
            checked={perosonalDetails.assignAboCheckbox}
            onChange={() => {
              setAssignAbo((prev) => !prev);
            }}
          />
        )}
        {iDontKnowABO &&
          (doNotKnowAboFlowType == DoNotKnowSponsorFlow.WITHOUT_POSTAL_CODE_SEARCH ||
            doNotKnowAboFlowType == DoNotKnowSponsorFlow.POSTAL_CODE_SEARCH) && (
            <LeadsSearch
              isFieldDisabled={isFieldDisabled}
              state={state}
              city={city}
              callback={(abo: SponsorSearchResponseInner | null) => {
                if (abo) {
                  dispatch(
                    updateRegistrationData({
                      selectSponsor: {
                        ...selectSponsor,
                        sponsor: abo,
                      },
                    }),
                  );
                }
                handleKnownABO(); //move to I know ABO step since user selected from leads list.
              }}
              doNotKnowAboFlowType={doNotKnowAboFlowType}
            />
          )}
      </>
    </div>
  );
};

export default RegistrationSponsor;
